import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import TextField from "../../../../../../ui/TextField";
import DataSelect from "../../../../../../ui/DataSelect";
import Checkbox from "../../../../../../ui/Checkbox";
import Grid from "@material-ui/core/Grid";
import { getOrganizations, getDepartments } from "../../../store/actions";
import { getDictPersonPost } from "../../../../../../Dict/store/actions";
import PropTypes from 'prop-types';
import TextMaskPhone from './TextMaskPhone';
import TextMaskSnils from './TextMaskSnils';

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  }
});

const initialInfo = {
  firstName: "", lastName: "", middleName: "",
  email: "", phone: "", snils: "", birthday: null,
  organization: null, sex: -1, post: null,
  department: null, startDate: null, register: true
}

const sexSelect = [
  {id: -1, name: "не указан"},
  {id: 0, name: "женский"},
  {id: 1, name: "мужской"},
];

const AddPersonForm = ({
  classes,
  getOrganizations,
  getDepartments,
  getDictPersonPost,
  organizations,
  departments,
  posts,
  disabled,
  onFormChange
}) => {
  const [data, setData] = React.useState(initialInfo);
  const {firstName, lastName, middleName, email, phone, snils, birthday,
    organization, sex, post, department, startDate, register } = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  React.useEffect(() => {
    getOrganizations();
    getDictPersonPost();
  }, []);

  React.useEffect(() => {
    if (organization) {
      getDepartments(organization);
    }
  }, [organization]);

  return (
    <div className={classes.root}>
          <Grid container spacing={1}>
              <Grid item xs={4}>
                <TextField
                  required
                  value={lastName}
                  onChange={e => onChange("lastName", e.target.value)}
                  label="Фамилия"
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  required
                  value={firstName}
                  onChange={e => onChange("firstName", e.target.value)}
                  label="Имя"
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  value={middleName}
                  onChange={e => onChange("middleName", e.target.value)}
                  label="Отчество"
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={4}>
                <DataSelect
                  value={sex}
                  onChange={value => onChange("sex", value.id)}
                  label="Пол"
                  dataSource={sexSelect}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  value={birthday}
                  onChange={e => onChange("birthday", e.target.value)}
                  label="Дата рождения"
                  format="dd.MM.yyyy"
                  type="date"
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  value={snils}
                  onChange={e => onChange("snils", e.target.value)}
                  label="СНИЛС"
                  disabled={disabled}
                  inputComponent={TextMaskSnils}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  value={phone}
                  onChange={e => onChange("phone", e.target.value)}
                  label="Телефон"
                  disabled={disabled}
                  inputComponent={TextMaskPhone}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  required
                  value={email}
                  onChange={e => onChange("email", e.target.value)}
                  label="E-mail"
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={4}>
                <Checkbox handleChange={() => onChange("register", !register)}
                          checked={register}
                          label="Отправить приглашение"/>
              </Grid>
              <Grid item xs={12}>
                {organizations && <DataSelect
                  value={organization}
                  onChange={value => onChange("organization", value.id)}
                  label="Организация"
                  dataSource={organizations}
                  disabled={disabled}
                />}
              </Grid>
              <Grid item xs={12}>
                {posts && <DataSelect
                  value={post}
                  onChange={value => onChange("post", value._key)}
                  label="Должность"
                  keyField="_key"
                  dataSource={posts}
                  disabled={disabled}
                />}
              </Grid>
              <Grid item xs={12}>
                {departments && <DataSelect
                  value={department}
                  onChange={value => onChange("department", value.id)}
                  label="Подразделение"
                  dataSource={departments}
                  disabled={disabled}
                />}
                  {/* <TreeviewField options={departments} label="Подразделение"/>
                  <Select
                      name="department"
                      label="Подразделение"
                      data={departmentsData}
                      inputLabelProps={{
                          shrink: true
                      }}
                  ></Select> */}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  value={startDate}
                  onChange={e => onChange("startDate", e.target.value)}
                  label="Дата начала работы"
                  format="dd.MM.yyyy"
                  type="date"
                  disabled={disabled}
                />
              </Grid>
          </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  isFetchingOrganizations: state.persons.isFetchingOrganizations,
  organizations: state.persons.organizations,
  isFetchingDepartments: state.persons.isFetchingDepartments,
  departments: state.persons.departments,
  isFetchingPosts: state.persons.isFetchingPosts,
  posts: state.dictAll.personPostList
});

const mapDispatchToProps = dispatch => ({
  getOrganizations: () => dispatch(getOrganizations()),
  getDepartments: (id) => dispatch(getDepartments(id)),
  getDictPersonPost: () => dispatch(getDictPersonPost())
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddPersonForm));
